
import MonetateService from "~/services/monetate.service";
import type { Product } from "~/types/ecom/product/product.type";
import type { RecTokenMap, TrolleyActions } from "~/types/monetate/monetate.type";
import { ProductService } from "~/services/product.service";

type Recommendations = {
  ids : string [],
  recTokens: RecTokenMap []
}

export const useMonetateStore = defineStore({
  id: "MonetateStore",
  state: () => ({

    // builder
    builder_recommendations_id : [] as string[],
    builder_component: 'you-may-also-like',
    builder_page_type: 'trolley' as String,
    monetate_item_add_ons: [] as Product[],


   // trolley_pop_up 
   trolley_pop_up_recommendations: <Recommendations>{},

   // Thank you page 
   order_confirmation_recommendations : <Recommendations>{},
  
   // pdp 
   pdp_everything_for_your_job : <Recommendations>{},
   pdp_others_also_looked_at : <Recommendations>{},
   pdp_similar_item : <Recommendations>{},
   
   // search page    
    search_recommendations : <Recommendations>{},

   // category detail page 
   category_detail_best_seller:  <Recommendations>{},
   category_detail_top_seller : <Recommendations>{},

   // plp - purchased and also purcchased 
   plp_recommendaions : <Recommendations>{},

   //trolley page cart 
   trolley_page_recommendations : <TrolleyActions>{},

  //  Account Page
  account_page_recommendations : <Recommendations>{},

  // Faq Page
  faq_page_recommendations: <Recommendations>{},

  // Social Proof 
  social_proof_data:<string>'',

  }),

 actions: {
    /**
     * Handles the impression event when a product is clicked.
     * @param productId - ID of the clicked product
     */

    // Add to cart event 

    async addToCartEvent(lineItems){
      let response = await new MonetateService().addToCartEvent(lineItems)
    },

    // purchase event 

    async purchaseEvent(order){
      const { purchaseEvent } = await import('~/stores-datalayer/monetate.datalayer');
      return await purchaseEvent(order);
    },

    async trackPlpView(){
      const { trackPlpView } = await import('~/stores-datalayer/monetate.datalayer');
      return await trackPlpView();
    },

    async trackRecommendationClick(state: Recommendations, id: string){
      const { trackRecommendationClick } = await import('~/stores-datalayer/monetate.datalayer');
      return await trackRecommendationClick(state,id);
    },
    
    async getproductFromId(){
      const { getproductFromId } = await import('~/stores-datalayer/monetate.datalayer');
      return await getproductFromId();
    }

  },

});